import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-view-business-identification',
  templateUrl: './view-business-identification.component.html',
  styleUrl: './view-business-identification.component.css'
})
export class ViewBusinessIdentificationComponent {
  @Input() businessIdentificationForm!: FormGroup;
  checkedArray: {key: string, value: string}[] = [{key:'Yes',value:'true'},{key:'No',value: 'false'} ];
  countryOfOrigin: {key: string, value: string}[] = [
    {key:'Belgium',value:'BE'}, {key:'France',value:'FR'}, {key:'Germany',value: 'DE'}, 
    {key:'Ireland',value:'IE'}, {key:'Italy',value:'IT'}, {key:'Netherlands',value:'NL'}, 
    {key:'Spain',value:'ES'}
  ];

  filteredBusinessType: any[] = [
    {key: 'option_fr_1', value: 'Sole Proprietorship (Entreprise Individuelle)'},
    {key: 'option_fr_2', value: 'Partnership (Société en Nom Collectif - SNC)'},
    {key: 'option_fr_3', value: 'Limited Liability Company (Société à Responsabilité Limitée - SARL)'},
    {key: 'option_fr_4', value: 'Public Limited Company (Société Anonyme - SA)'},
    {key: 'option_fr_5', value: 'Simplified Joint-Stock Company (Société par Actions Simplifiée - SAS)'},
    {key: 'option_fr_6', value: 'Micro-Entreprise (Micro-Entreprise)'},
    {key: 'option_fr_7', value: 'Société en commandite simple'},
    {key: 'option_fr_8', value: 'Société en commandite par actions'},
    {key: 'option_de_1', value: 'Sole Proprietorship (Einzelunternehmen)'},
    {key: 'option_de_2', value: 'Partnership (Personengesellschaft)'},
    {key: 'option_de_2_1', value: 'General Partnership (Offene Handelsgesellschaft - OHG)'},
    {key: 'option_de_2_2', value: 'Limited Partnership (Kommanditgesellschaft - KG)'},
    {key: 'option_de_3', value: 'Limited Liability Company (Gesellschaft mit beschränkter Haftung - GmbH)'},
    {key: 'option_de_4', value: 'Public Limited Company (Aktiengesellschaft - AG)'},
    {key: 'option_nl_1', value: 'Sole Proprietorship (Eenmanszaak)'},
    {key: 'option_nl_2', value: 'Partnership (Vennootschap onder Firma - VOF)'},
    {key: 'option_nl_3', value: 'Private Limited Company (Besloten Vennootschap - BV)'},
    {key: 'option_nl_4', value: 'Public Limited Company (Naamloze Vennootschap - NV)'},
    {key: 'option_nl_5', value: 'Cooperative (Coöperatie)'},
    {key: 'option_be_1', value: 'Onderneming in eigen naam / Entreprise en nom personnel'},
    {key: 'option_be_2', value: 'Besloten Vennootschap (BV) / Société à responsabilité limitée (SRL)'},
    {key: 'option_be_3', value: 'Naamloze Vennootschap (NV) / Société Anonyme (SA)'},
    {key: 'option_be_4', value: 'Vennootschap onder Firma (VOF) / Société en Nom Collectif (SNC)'},
    {key: 'option_be_5', value: 'Commanditaire Vennootschap (CommV) / Société en commandite simple (SCS)'},
    {key: 'option_be_6', value: 'Coöperatieve Vennootschap (CV) / Société Coopérative (SC)'},
    {key: 'option_ie_1', value: 'Sole Trader'},
    {key: 'option_ie_2', value: 'Private Company Limited by Shares (LTD)'},
    {key: 'option_ie_3', value: 'Public Limited Company (PLC)'},
    {key: 'option_ie_4', value: 'Partnership (General Partnership)'},
    {key: 'option_ie_5', value: 'Limited Partnership (LP)'},
    {key: 'option_ie_6', value: 'Co-operative Society'},
    {key: 'option_it_1', value: 'Impresa Individuale (Ditta Individuale)'},
    {key: 'option_it_2', value: 'Società a Responsabilità Limitata (S.r.l.)'},
    {key: 'option_it_3', value: 'Società per Azioni (S.p.A.)'},
    {key: 'option_it_4', value: 'Società in Nome Collettivo (S.n.c.)'},
    {key: 'option_it_5', value: 'Società in Accomandita Semplice (S.a.s.)'},
    {key: 'option_it_6', value: 'Società Cooperativa (S.C.)'},
    {key: 'option_es_1', value: 'Empresario Individual (Autónomo)'},
    {key: 'option_es_2', value: 'Sociedad Limitada (S.L.)'},
    {key: 'option_es_3', value: 'Sociedad Anónima (S.A.)'},
    {key: 'option_es_4', value: 'Sociedad Colectiva'},
    {key: 'option_es_5', value: 'Sociedad Comanditaria Simple (S.Com.)'},
    {key: 'option_es_6', value: 'Sociedad Cooperativa (S. Coop.)'}
  ];

  howDidYouHearAboutUs: {key: string, value: string}[] = [

    {
      "key": "corporate_partner_orgnaisation",
      "value": "Corporate / Partner Organisation"
    },
    {
      "key": "event",
      "value": "Event"
    },
    {
      "key": "friend_colleague",
      "value": "Friend / Colleague"
    },
    {
      "key": "esdp",
      "value": "ESDP"
    },
    {
      "key": "msduk",
      "value": "MSDUK"
    },
    {
      "key": "press",
      "value": "Press"
    },
    {
      "key": "university",
      "value": "University"
    },
    {
      "key": "other",
      "value": "Other"
    }
  ]

}
